import { Dialog, Typography } from '@mui/material'
import { InfoCardIcon } from 'components/atoms/Icons'
import InCardStack from 'components/atoms/container/InCardStack'
import shareMegaphoneIcon from 'assets/images/shareMegaphone.svg'
import AddRatersCard from 'components/organisms/assessments/AddRatersCard'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import { ConfidentialIcon } from './AddRatersDescriptions'

const AddMoreRatersPopup = ({ open, setOpen, assessmentData, goalId }) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth='xl'
      PaperProps={{sx: {overflowX: 'hidden'}}} // Horrizontal scroll bar fix
       >
      <InCardStack
        width={800}
        paddingY={16}
        minHeight={500}>
        <InfoCardIcon src={shareMegaphoneIcon} />
        <RowStack width='unset' spacing={2}>
          <Typography variant='h1'>
            {t('addRaters.inviteOthersToRate')}
          </Typography>
          <ConfidentialIcon />
        </RowStack>
        {open && (
          <AddRatersCard
            fromSelfAssessment={false}
            goalId={parseInt(goalId, 10)}
            data={assessmentData}
            buttonDirection='row'
            completeCallback={() => setOpen(false)}
            inPopup={true}
          />
        )}
      </InCardStack>
    </Dialog>
  )
}

export default AddMoreRatersPopup
